
export default function Leaderboard() {
  const topStreamers = [
    {
      rank: 1,
      name: 'CryptoKing_PSU',
      platform: 'Twitch',
      points: 15420,
      avatar: 'https://public.readdy.ai/ai/img_res/791c96a8a5bcd61158291bcd1a003151.jpg',
      badge: 'crown',
      change: '+12%'
    },
    {
      rank: 2,
      name: 'PumpQueen_Live',
      platform: 'YouTube',
      points: 14850,
      avatar: 'https://readdy.ai/api/search-image?query=Female%20streamer%20avatar%20with%20professional%20gaming%20setup%20and%20purple%20lighting.%20Confident%20content%20creator%20with%20modern%20streaming%20equipment%20and%20cryptocurrency%20themed%20background.%20Clean%20portrait%20style%20with%20futuristic%20neon%20elements%20and%20high-tech%20environment.&width=100&height=100&seq=avatar-2&orientation=squarish',
      badge: 'medal',
      change: '+8%'
    },
    {
      rank: 3,
      name: 'StreamMaster_X',
      platform: 'Twitch',
      points: 13990,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20streamer%20avatar%20with%20green%20and%20purple%20gaming%20setup.%20Modern%20content%20creator%20with%20headset%20in%20high-tech%20streaming%20room.%20Cryptocurrency%20and%20blockchain%20themed%20background%20with%20neon%20lighting.%20Clean%20portrait%20style%20with%20futuristic%20elements.&width=100&height=100&seq=avatar-3&orientation=squarish',
      badge: 'trophy',
      change: '+15%'
    },
    {
      rank: 4,
      name: 'PumpGuru_PSU',
      platform: 'YouTube',
      points: 12750,
      avatar: 'https://readdy.ai/api/search-image?query=Experienced%20streamer%20avatar%20with%20professional%20setup%20and%20cryptocurrency%20displays.%20Confident%20content%20creator%20with%20modern%20gaming%20equipment%20and%20purple%20neon%20lighting.%20High-tech%20streaming%20environment%20with%20blockchain%20visual%20elements.%20Clean%20portrait%20style.&width=100&height=100&seq=avatar-4&orientation=squarish',
      badge: 'star',
      change: '+5%'
    },
    {
      rank: 5,
      name: 'CoinStreamer_Pro',
      platform: 'Twitch',
      points: 11980,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20streamer%20avatar%20with%20green%20and%20purple%20gaming%20setup%20background.%20Modern%20content%20creator%20with%20headset%20and%20cryptocurrency%20themed%20streaming%20room.%20Clean%20portrait%20style%20with%20futuristic%20neon%20lighting%20and%20high-tech%20elements.&width=100&height=100&seq=avatar-5&orientation=squarish',
      badge: 'diamond',
      change: '+22%'
    }
  ];

  const getBadgeIcon = (badge: string) => {
    switch (badge) {
      case 'crown': return 'ri-crown-fill text-yellow-400';
      case 'medal': return 'ri-medal-fill text-gray-300';
      case 'trophy': return 'ri-trophy-fill text-amber-600';
      case 'star': return 'ri-star-fill text-blue-400';
      case 'diamond': return 'ri-diamond-fill text-cyan-400';
      default: return 'ri-award-fill text-gray-400';
    }
  };

  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'from-yellow-500/20 to-yellow-600/20 border-yellow-500/30';
    if (rank === 2) return 'from-gray-400/20 to-gray-500/20 border-gray-400/30';
    if (rank === 3) return 'from-amber-600/20 to-amber-700/20 border-amber-600/30';
    return 'from-slate-700/20 to-slate-800/20 border-slate-600/30';
  };

  return (
    <section className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-emerald-500/5"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-emerald-400 mb-8">
            Top Streamers
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-emerald-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Meet our elite streamers who are leading the PSU leaderboard this week.
          </p>
        </div>

        <div className="bg-gradient-to-br from-slate-800/30 to-slate-900/30 rounded-3xl p-8 border border-gray-700/30">
          {/* Header */}
          <div className="grid grid-cols-12 gap-4 mb-6 pb-4 border-b border-gray-700/50">
            <div className="col-span-1 text-center">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wider">Rank</span>
            </div>
            <div className="col-span-5">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wider">Streamer</span>
            </div>
            <div className="col-span-2 text-center">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wider">Platform</span>
            </div>
            <div className="col-span-2 text-center">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wider">Points</span>
            </div>
            <div className="col-span-2 text-center">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wider">Change</span>
            </div>
          </div>

          {/* Leaderboard entries */}
          <div className="space-y-4">
            {topStreamers.map((streamer, index) => (
              <div
                key={index}
                className={`grid grid-cols-12 gap-4 items-center p-4 rounded-2xl bg-gradient-to-r ${getRankStyle(streamer.rank)} border hover:scale-[1.02] transition-all duration-300`}
              >
                {/* Rank */}
                <div className="col-span-1 text-center">
                  <div className="relative">
                    <span className="text-2xl font-black text-white">#{streamer.rank}</span>
                    {streamer.rank <= 3 && (
                      <i className={`${getBadgeIcon(streamer.badge)} absolute -top-1 -right-1 text-sm`}></i>
                    )}
                  </div>
                </div>

                {/* Streamer info */}
                <div className="col-span-5 flex items-center">
                  <div className="relative mr-4">
                    <img
                      src={streamer.avatar}
                      alt={streamer.name}
                      className="w-12 h-12 rounded-full object-cover border-2 border-emerald-500/30"
                    />
                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-slate-900"></div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white">{streamer.name}</h3>
                    <div className="flex items-center text-sm text-gray-400">
                      <i className="ri-live-fill text-red-500 mr-1"></i>
                      <span>Live now</span>
                    </div>
                  </div>
                </div>

                {/* Platform */}
                <div className="col-span-2 text-center">
                  <div className="flex items-center justify-center">
                    <i className={`${streamer.platform === 'Twitch' ? 'ri-twitch-fill text-purple-400' : 'ri-youtube-fill text-red-400'} mr-2`}></i>
                    <span className="text-gray-200 font-medium">{streamer.platform}</span>
                  </div>
                </div>

                {/* Points */}
                <div className="col-span-2 text-center">
                  <span className="text-xl font-bold text-emerald-400">{streamer.points.toLocaleString()}</span>
                </div>

                {/* Change */}
                <div className="col-span-2 text-center">
                  <div className="flex items-center justify-center">
                    <i className="ri-arrow-up-line text-emerald-400 mr-1"></i>
                    <span className="text-emerald-400 font-bold">{streamer.change}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View all button */}
          <div className="text-center mt-8">
            <button className="inline-flex items-center px-8 py-4 text-lg font-bold text-white bg-gradient-to-r from-purple-600 to-emerald-600 rounded-full hover:from-purple-500 hover:to-emerald-500 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-list-check-3 mr-3"></i>
              View Full Leaderboard
              <i className="ri-external-link-line ml-3"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
